export enum UsageCodeEnum {
    CODE11001 = '11001',
    CODE21001 = '21001',
    CODE21002 = '21002',
    CODE22001 = '22001',
    CODE31001 = '31001',
    CODE33001 = '33001',
    CODE33A001 = '33a001',
    CODE41001 = '41001',
    CODE43001 = '43001',
    CODE44001 = '44001',
    CODE45001 = '45001',
    CODE46001 = '46001',
    CODE47001 = '47001',
    CODE51001 = '51001',
    CODE52001 = '52001',
    CODE53001 = '53001',
    CODE54001 = '54001',
    CODE55001 = '55001',
    CODE56001 = '56001',
}
